export enum KnownDuplicateReason {
  Order = 'O',
  Shipment = 'S',
  Both = 'S, O'
}
